import { STATUS_EXCHANGE } from "@/api/types/common.enums";

/**
 * Статусы, после которых заявка больше не меняется. На них выключаем опрос
 * сервера и убираем плашку активного обмена.
 */
const FINAL_STATUSES: STATUS_EXCHANGE[] = [
  STATUS_EXCHANGE.OK,
  STATUS_EXCHANGE.CANCELED,
  STATUS_EXCHANGE.ERROR_BANK,
  STATUS_EXCHANGE.ERROR_INIT,
  STATUS_EXCHANGE.REFUNDED,
];

/** Статусы, на которых шаг таймлайна показывается как сорванный. */
const FAILED_STATUSES: STATUS_EXCHANGE[] = [
  STATUS_EXCHANGE.CANCELED,
  STATUS_EXCHANGE.ERROR_BANK,
  STATUS_EXCHANGE.ERROR_INIT,
  STATUS_EXCHANGE.REFUNDED,
  STATUS_EXCHANGE.REFUND_REQUESTED,
];

export const isFinalStatus = (status?: STATUS_EXCHANGE | null) =>
  !!status && FINAL_STATUSES.includes(status);

export const isFailedStatus = (status?: STATUS_EXCHANGE | null) =>
  !!status && FAILED_STATUSES.includes(status);

export const isDoneStatus = (status?: STATUS_EXCHANGE | null) =>
  status === STATUS_EXCHANGE.OK;
